














import grassdoorSupportedProductMixin from 'library/mixins/grassdoor-supported-product'
import productCardMixin from './product-card-mixin'

export default
	name: 'THCProductCard'

	mixins: [ productCardMixin, grassdoorSupportedProductMixin ]

	watch:

		# Fire GTM impression event once we have Grassdoor products
		'$store.state.cart.hydrated':
			immediate: true
			handler: (hydrated) ->
				return unless hydrated
				@$gtmNonEcomm.productImpression @productWithGrassdoorVariants, el: @$el

	methods:

		# Fire product click event
		fireProductClick: (clickEvent) ->
			if @hasGrassdoorVariants
			then grassdoorCart.trackProductClicked @grassdoorProducts[0]
			else @$gtmNonEcomm.productClick @product, {
				el: @$el
				clickEvent
			}

